import React, { memo } from 'react'
import cn from 'classnames'
import styles from './VNMenuQuantity.module.scss'

const VNMenuQuantity = ({ value, color = 'inherit', useDark = false, isScannableItem = false }) => {
  if (value) {
    return <span className={cn(styles.quantity, { [styles.darker]: useDark })}>{value}</span>
  }

  return (
    <span
      className={cn(styles.add, { [styles.scannableItem]: !isScannableItem })}
      style={{ color, marginLeft: isScannableItem ? `undefined !important` : 'auto' }}
    />
  )
}

export default memo(VNMenuQuantity)
